export function changeUserAvatar(avatar) {
  return {
    type: 'CHANGE_AVATAR',
    avatar
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/Header/actions.js